export default __webpack_public_path__ + "static/media/incorrect18.6c7edb76.mp3";